import script from "./SidebarItems.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarItems.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&lang=css&external"
import "./SidebarItems.vue?vue&type=style&index=1&id=34179013&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34179013"]])

export default __exports__